<template>
  <span>
    <span>添付ファイル一覧</span>
    <table class="unstriped boss-table pega-mb-20 pega-file-download">
      <thead>
        <tr>
          <th class="boss-table-head-center file-name">
            ファイル名
          </th>
          <th class="boss-table-head-center">
            送信日時
          </th>
          <th class="boss-table-head-center file-period">
            閲覧期限
            <span
              v-tooltip="{ content: '応募者がマイページ上でファイルを閲覧できる期限。これを過ぎると閲覧できなくなります。'}"
              class="pega-circle"
            >?
            </span>
          </th>
          <th class="boss-table-head-center file-operation">
            操作メニュー
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-if="summaryFiles.length">
          <template v-for="(summaryFile, i) in summaryFiles">
            <entry-message-attachment-file
              :key="i"
              :entry-id="entryId"
              :summary-file="summaryFile"
              @fetchAllMessage="$emit('fetchAllMessage')"
            />
          </template>
        </template>
        <tr v-else>
          <td
            colspan="4"
            data-test="no-file"
            class="text-center boss-text"
          >
            送信したファイルはありません。
          </td>
        </tr>
      </tbody>
    </table>
  </span>
</template>

<script>
import EntryMessageAttachmentFile from '@/components/molecules/EntryMessageAttachmentFile'

export default {
  components: {
    EntryMessageAttachmentFile
  },
  props: {
    summaryFiles: {
      type: Array,
      default: () => []
    },
    entryId: {
      type: Number,
      required: true
    }
  }
}
</script>
